<template>
  <div class="subject-modal">
    <b-modal
      id="modal-subject"
      ref="modal"
      centered
      title="Create Quote"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="subject-modal-form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Enter email subject"
          label-for="subject-input"
          invalid-feedback="Subject is required"
          :state="subjectState"
        >
          <b-form-input
            id="subject-input"
            v-model="subject"
            :state="subjectState"
            placeholder="Subject..."
            required
          ></b-form-input>
        </b-form-group>
      </form>
      <template #modal-footer="{ cancel }">
        <b-button
          class="subject-modal-form__btn1"
          size="sm"
          variant="info"
          :disabled="creating"
          @click="addQuote()"
        >
          <i class="fas fa-check"></i> Ok
        </b-button>
        <b-button
          class="subject-modal-form__btn2"
          size="sm"
          variant="secondary"
          @click="cancel()"
        >
          <i class="fas fa-trash-alt"></i> Cancel
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "subjectModal",
  props: {
    departmentId: Number
  },
  components: {},
  data() {
    return {
      subject: null,
      subjectState: null,
      actualQueue: null,
      creating: false
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"])
  },
  methods: {
    async addQuote() {
      this.actualQueue = localStorage.getItem("actual-queue");
      if (!this.checkFormValidity()) {
        return;
      }
      this.creating = true;
      let info = {};
      info.department = this.departmentId;
      info.subject = this.subject;
      info.entry_type = this.actualQueue
        ? this.actualQueue === "drayage"
          ? "DRAYAGE-Manual"
          : "OTR-Manual"
        : "Manual";
      let response = await this.$store.dispatch("quotes/createQuote", info);
      if (response.status == 201) {
        this.swal({
          title: "Success!",
          text: "Quote has been created",
          icon: "success",
          buttons: false,
          timer: 2000
        });
        this.$nextTick(() => {
          this.$bvModal.hide("modal-subject");
        });
        this.$emit("updateSubject");
      }
      this.creating = false;
    },
    resetModal() {
      this.subject = "";
      this.subjectState = null;
      this.creating = false;
    },
    checkFormValidity() {
      const valid = this.subject.length > 0 ? true : false;
      this.subjectState = valid;
      return valid;
    }
  }
};
</script>

<style lang="scss" scoped>
.subject-modal-form {
  &__btn1 {
    background-color: $color-primary-button;
  }
}
</style>
